define('common/js/lib/Serum.Statistics',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'module',
  'coreAnalytics',
  'common/js/lib/Serum.CookieStore'
], function ($, Pubsub, module, ca, cookieStore) {

  'use strict';

  var polopolyIdPrefix = 'pp:';
  var trackerData = {};

  function getAuthorsArray () {
    var authors = [],
      authorTags = document.querySelectorAll('address.author a'),
      i;

    for (i = 0; i < authorTags.length; i++) {
      authors.push(authorTags[i].textContent);
    }

    return authors;
  }

  var MOBILE_UA = /brew|up.browser|openweb|midp|iphone|ipod|symbian|series60|series70|serie brew|s80|series90|windows ce|iemobile|wm5 pie|blackberry|palm|blazer|xiino|android|danger|hiptop| pda|mobile|up.link|sonyericsson|ericsson|sec-sgh|docomo|kddi|vodafone/i, // eslint-disable-line no-unused-vars
    PAD_UA = /ipad/i, // eslint-disable-line no-unused-vars
    initialized = false;

  var queryMap = (function () {
    var href = document.location.href.split('?'),
      query = href[href.length - 1],
      params = query.split('&'),
      obj = {};
    for (var i = 0, l = params.length; i < l; i++) {
      var param = params[i].split('=');
      if (param.length > 1) {
        obj[param[0]] = param[1];
      }
    }
    return obj;
  })();

  // Google Analytics Universal Global namespace
  window.ga = window.ga || function () {
    (window.ga.q = window.ga.q || []).push(arguments);
  };
  window.ga.l = Date.now();


  // Newsbeat Global namespaces
  window._sf_async_config = window._sf_async_config || {};

  // implicit (defined in Serum.Statistics.Head.js) :

  function isProdDomain () {
    return (/^(www.)?nrk.no/).test(queryMap.debugUrl || window.location.hostname);
  }

  function getCategory () {
    return module.config().statisticCategory;
  }

  function getReferrerForAnalytics () {
    if (document.referrer) {
      return document.referrer;
    } else if (window.location.search.match(/viewContext=([a-z.]+)/)) {
      /**
       * PUB-14329
       * If page is referred to from a native app
       * webview, set the viewContext as referer
       */
      var matched = window.location.search.match(/viewContext=([a-z.]+)/);
      return 'nrkapp://' + matched[1];
    }

    return undefined;
  }
  /**
   * PUB-12407
   * Conversion of data format from Panorama provided metrics to
   * actual Google Analytics dimensions and contentGroups as
   * specified in https://github.com/nrkno/analytics-docs
   */
  /* eslint-disable complexity */
  /**
   * eslint triggers error:
   * Function 'getNormalizedGaMetrics' has a complexity of 12
   * for no apparent reason.
   */
  function getNormalizedGaMetrics () {
    var providedMetrics = module.config().statisticsData,
      normalizedMetrics = {};

    if (typeof providedMetrics !== 'object') {
      return {};
    }

    if (providedMetrics.contentId) {
      normalizedMetrics['dimension1'] = polopolyIdPrefix + providedMetrics.contentId;
    }
    if (providedMetrics.contentTitle) {
      normalizedMetrics['dimension2'] = providedMetrics.contentTitle;
    }
    if (providedMetrics.contentPublishedYear) {
      normalizedMetrics['dimension3'] = String(providedMetrics.contentPublishedYear);
    }
    if (providedMetrics.contentPublishedMonth) {
      normalizedMetrics['dimension4'] = String(providedMetrics.contentPublishedMonth);
    }
    if (providedMetrics.contentPublishedDay) {
      normalizedMetrics['dimension5'] = String(providedMetrics.contentPublishedDay);
    }
    if (providedMetrics.articleUniverses) {
      normalizedMetrics['dimension12'] = providedMetrics.articleUniverses;
    }
    if (providedMetrics.contentType) {
      normalizedMetrics['contentGroup1'] = providedMetrics.contentType;
    }
    if (providedMetrics.contentCategoryTitle) {
      normalizedMetrics['contentGroup2'] = providedMetrics.contentCategoryTitle;
    }
    if (providedMetrics.contentCategoryId) {
      normalizedMetrics['contentGroup3'] = polopolyIdPrefix + providedMetrics.contentCategoryId;
    }
    if (providedMetrics.contentFolderId) {
      normalizedMetrics['contentGroup4'] = polopolyIdPrefix + providedMetrics.contentFolderId;
    }
    if (providedMetrics.articleType) {
      normalizedMetrics['contentGroup5'] = providedMetrics.articleType;
    }
    if (window.__browser_feature_score__) {
      normalizedMetrics['dimension35'] = window.__browser_feature_score__;
    }

    return normalizedMetrics;
  }
  /* eslint-enable */

  var providers = {
    /*
     * Google Analytics integration. Uses PubSub to listen for track events
     * rather than expose the ga object directly.
     *
     * Custom throttling mechanism was added in PUB-12445, where at the time the
     * official Google documentation specified a quota per tracked session of 2
     * hits per second with an additional 20 hit buffer for bursts
     *
     * Support for configurable viewContext and communication with native app
     * webviews via the nativeBridge module added in PUB-12728
    */
    GA: {
      initialized: false,
      /**
       * Google Analytics
       *
       * @private */
      setup: function setupGA () {
        var nbURL = module.config().NATIVEBRIDGE_URL || 'https://static.nrk.no/nativebridge/latest/nativebridge.min.js';

        if (providers.GA.initialized || !getCategory()) {
          return;
        }

        if (nbURL && queryMap['viewContext'] && queryMap['bridgeVersion'].match(/^\d+\.\d+\.\d+$/)) {
          providers.GA.isAppView = true;
          require([nbURL], function (nativeBridge) {
            nativeBridge.rpc({
              topic: 'gaConf',
              data: {},
              resolve: function (gaConf) {
                if (gaConf && gaConf.cid) {
                  providers.GA.initialize({
                    cid: gaConf.cid,
                    viewContext: queryMap['viewContext']
                  });
                } else {
                  providers.GA.initialize({
                    viewContext: queryMap['viewContext']
                  });
                }
              },
              reject: function (error) {
                providers.GA.initialize({
                  viewContext: queryMap['viewContext'],
                  error: error
                });
              },
              timeout: 1000
            })
          });
        } else {
          providers.GA.initialize();
        }
      },

      initialize: function initializeGA (options) {
        trackerData = getNormalizedGaMetrics();

        var trackerConfig = {
          trackingId: module.config().GAU_CODE,
          cookieDomain: 'auto'
        };

        window.coreAnalytics('initialize', {
          trackerName: 'nrknoserum',
          ga: module.config().GAU_CODE
        });

        var userId = cookieStore.getCookie('nrkno-sub');
        if (userId) {
          window.coreAnalytics('context', {
            userId: userId
          });
        }
        trackerData.anonymizeIp = true;

        // options for alternative view contexts (web view in apps)
        if (options) {
          if (options.gaCid) {
            trackerConfig.clientId = options.gaCid;
          }

          if (options.viewContext) {
            trackerData.dimension33 = navigator.userAgent;
            trackerData.dimension34 = options.viewContext;
          }

          if (options.error) {
            window.ga('send', 'exception', options.error.message);
          }
        }

        window.ga('create', trackerConfig);
        if (navigator.sendBeacon) {
          window.ga('set', 'transport', 'beacon');
        }
        window.ga('set', trackerData);
        // load eCommerce plugin
        window.ga('require', 'ec');

        providers.GA.initialized = true;
        providers.GA.hitBuffer = 20; // initial buffer size for event throttling
        providers.GA.hitReplenishTime = 500; // time for a hit to replenish in milliseconds
        setTimeout(providers.GA.replenishHit, providers.GA.hitReplenishTime);

        Pubsub.publish(Pubsub.topics.TRACK_PAGE, {
          type: 'GA'
        });

        /* PUB-12957 Note on error wrapping/reporting
         * Up until now the GA object has been a locally created object, which
         * will be replaced with the real GA object when loading the GA script.
         * We use GA for error reporting, so if the load operation fails we can't
         * report errors anyway. Therefore loading isn't wrapped, but all calls following
         * load will be.
         */
        require([module.config().GAU_URL]);
      },

      /*
       * Subtract a hit from the buffer, and automatically add a new hit to the buffer in 500ms
       */
      useHit: function useHit () {
        providers.GA.hitBuffer--;
      },

      replenishHit: function replenishHit () {
        if (providers.GA.hitBuffer < 20) {
          providers.GA.hitBuffer++;
        }
        setTimeout(providers.GA.replenishHit, providers.GA.hitReplenishTime);
      },

      /**
       * Google Analytics event tracking
       *
       * Usage:
       * http://code.google.com/intl/no-NO/apis/analytics/docs/tracking/eventTrackerGuide.html
       *
       * @public */
      trackEvent: function trackEvent (category, action, label, value, fieldsObject) {
        if (providers.GA.hitBuffer > 0) {
          providers.GA.useHit();
          // PUB-12957 catch and rethrow errors for better error reporting
          try {
            window.ga('send', 'event', category, action, label, value, fieldsObject);
          } catch (e) {
            throw e;
          }
        } else {
          setTimeout(function () {
            providers.GA.trackEvent(category, action, label, value, fieldsObject);
          }, providers.GA.hitReplenishTime);
        }
      },

      /**
       * Track page view in google analytics
       *
       * Usage:
       * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiBasicConfiguration?hl=no-NO#_gat.GA_Tracker_._trackPageview
       *
       * @private */
      trackPage: function trackPageGA () {
        providers.GA.useHit();
        window.coreAnalytics('pageview', {
          contentId: trackerData.dimension1,
          ga: trackerData,
          referrer: getReferrerForAnalytics(),
          tnsSection: getCategory()
        });
      },

      /**
       * GA eCommerce Impression tracking
       *
       * Usage:
       * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#impression-data
       *
       * @private */
      trackEcImpression: function trackImpressionView (data) {
        if (data.item && data.event) {
          // PUB-12957 catch and rethrow errors for better error reporting
          try {
            window.ga('ec:addImpression', data.item);
          } catch (e) {
            throw e;
          }
          providers.GA.trackEvent(data.event.category, data.event.action, data.event.label);
        }
      },

      /**
       * GA eCommerce click tracking
       *
       * Usage:
       * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#product-data
       *
       * @private */
      trackEcClick: function trackEcClick (data) {
        if (data.item && data.event) {
          // PUB-12957 catch and rethrow errors for better error reporting
          try {
            window.ga('ec:addProduct', data.item);
            window.ga('ec:setAction', 'click', {list: data.item.list});
          } catch (e) {
            throw e;
          }
          providers.GA.trackEvent(data.event.category, data.event.action, data.event.label);
        }
      },

      /**
       * GA eCommerce detail tracking
       *
       * Usage:
       * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#product-detail-view
       *
       * @private */
      trackEcDetail: function trackEcDetail (data) {
        if (data.item && data.event) {
          // PUB-12957 catch and rethrow errors for better error reporting
          try {
            window.ga('ec:addProduct', data.item);
            window.ga('ec:setAction', 'detail', {list: data.item.list});
          } catch (e) {
            throw e;
          }

          providers.GA.trackEvent(data.event.category, data.event.action, data.event.label);
        }
      },

      /**
       * GA eCommerce start consumption tracking
       *
       * Usage:
       * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#add-remove-cart
       *
       * @private */
      trackEcConsumptionStart: function trackEcConsumptionStart (data) {
        if (data.item && data.event) {
          // PUB-12957 catch and rethrow errors for better error reporting
          try {
            window.ga('ec:addProduct', data.item);
            window.ga('ec:setAction', 'add', {list: data.item.list});
          } catch (e) {
            throw e;
          }

          providers.GA.trackEvent(data.event.category, data.event.action, data.event.label);
        }
      },

      /**
       * GA eCommerce completed consumption tracking
       *
       * Usage:
       * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#checkout-process
       *
       * @private */
      trackEcConsumptionComplete: function trackEcConsumptionComplete (data) {
        if (data.item && data.event) {
          // PUB-12957 catch and rethrow errors for better error reporting
          try {
            window.ga('ec:addProduct', data.item);
            window.ga('ec:setAction', 'checkout', {list: data.item.list});
          } catch (e) {
            throw e;
          }

          providers.GA.trackEvent(data.event.category, data.event.action, data.event.label);
        }
      },

      /**
       * Sets server-side rendered Google Optimize experiment & variant ids.
       *
       * Usage:
       * https://developers.google.com/optimize/devguides/experiments
       *
       * Multiple experiments is undocumented, but ! separator works and is used by Optimize
       * when running client-side experiments.
       *
       * @private */
      trackExperiments: function (experiments) {
        var experimentCount = (experiments && experiments.length) || 0;
        if (experimentCount) {
          var concatOptimizeExperiments = experiments
            .map(function (experiment) {
              return experiment.id + '.' + experiment.variant;
            })
            .join('!');

          window.ga('set', 'exp', concatOptimizeExperiments);

          providers.GA.trackEvent(
              'pageLoad',
              'registerExperiments',
              'Page was loaded with ' + experimentCount +' experiments',
              experimentCount,
              {nonInteraction: true}
          )
        }
      }
    },

    Linkpulse: {
      initialized: false,

      setup: function setupLinkpulse () {
        if (providers.Linkpulse.initialized) {
          return;
        }
        if (!getCategory()) {
          return;
        }

        //Log video start (PUB-10391)
        Pubsub.subscribe(Pubsub.topics.VIDEO_DID_START, function (data) {
          // PUB-12957
          // catch and rethrow errors for better error reporting via window.onerror
          try {
            LP4.logClick({ // eslint-disable-line no-undef
              position: 'video_start',
              fromUrl: location.href,
              toUrl: data.video.getAbsoluteOriginUrl()
            });
          } catch (e) {
            throw e;
          }
        });

        require([module.config().LP_URL], function () {
          Pubsub.publish(Pubsub.topics.TRACK_PAGE, {
            type: 'Linkpulse'
          });
          providers.Linkpulse.initialized = true;
        });

      },

      inlineTrack: false, // Flag to avoid double tracking on initial pageload in ajax environments.

      trackPage: function trackLinkpulse () {
        if (!providers.Linkpulse.initialized || !getCategory() || typeof LP4 === 'undefined') {
          return;
        }

        // PUB-12957
        // catch and rethrow errors for better error reporting via window.onerror
        try {
          // Specify current URL, neccessary to override the stored current URL when navigating inline/logging clicks
          LP4.setUrl(location.href); // eslint-disable-line no-undef
          // Manually log pageview
          LP4.logPageview({ // eslint-disable-line no-undef
            'url': location.href
          });
        } catch (e) {
          throw e;
        }
      }

    },


    Newsbeat: {
      initialized: false,

      /**
       * NewsBeat
       *
       * @private */
      setup: function setupNewsbeat () {

        if (providers.Newsbeat.initialized) {
          return;
        }
        providers.Newsbeat.initialized = true;

        function loadChartbeat () {
          require([module.config().NEWSBEAT_URL], function () {

          });
        }

        // do not track if this is used on other domains than production, or statisticscategory is not present
        if (isProdDomain() && getCategory()) {

          var authors = getAuthorsArray();
          var sections = document.location.pathname;
          var typeMetaTag = document.querySelector('meta[property="og:type"]');
          var type = typeMetaTag ? typeMetaTag.getAttribute('content') : null;

          sections = sections.substring(0, sections.lastIndexOf('/'));

          _sf_async_config = { // eslint-disable-line no-undef
            uid: 30584,
            domain: 'nrk.no',
            useCanonical: true,
            type: type || 'website',
            authors: authors.length > 0 ? authors.join(',') : 'NRK',
            sections: sections
          };

          // load script
          if (_sf_loaded === true) { // eslint-disable-line no-undef
            loadChartbeat();
          } else {
            var oldonload = window.onload;
            window.onload = (typeof window.onload !== 'function') ? loadChartbeat :
              function () {
                _sf_endpt = new Date().getTime(); // eslint-disable-line no-undef
                oldonload();
                loadChartbeat();
              };
          }
        }

        Pubsub.publish(Pubsub.topics.TRACK_PAGE, {
          type: 'Newsbeat'
        });

      },

      trackPage: function trackPageNewsbeat () {
        if (!getCategory() || typeof pSUPERFLY === 'undefined') {
          return;
        }
        pSUPERFLY.virtualPage(location.href, document.title); // eslint-disable-line no-undef
      }

    }

  };

  // initialize
  function initialize () {
    if (initialized) {
      return;
    }

    /**
     * Setup global subscribers
     */
    Pubsub.subscribe(Pubsub.topics.TRACK_EVENT, function (obj) {
      // track to GA
      if (providers.GA.initialized) {
        providers.GA.trackEvent(obj.category, obj.action, obj.label, obj.value, obj.fieldsObject);
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_PAGE, function (data) {
      if (data && data.type) {
        providers[data.type].trackPage();
      } else {
        for (var key in providers) {
          if (providers.hasOwnProperty(key)) {
            providers[key].trackPage();
          }
        }
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_FWDNAV_IMPRESSION, function (data) {
      if (data && data.item && data.event) {
        providers.GA.trackEcImpression(data);
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_FWDNAV_CLICK, function (data) {
      if (data && data.item && data.event) {
        providers.GA.trackEcClick(data);
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_FWDNAV_DETAIL, function (data) {
      if (data && data.item && data.event) {
        providers.GA.trackEcDetail(data);
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_FWDNAV_STARTED, function (data) {
      if (data && data.item && data.event) {
        providers.GA.trackEcConsumptionStart(data);
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_FWDNAV_COMPLETED, function (data) {
      if (data && data.item && data.event) {
        providers.GA.trackEcConsumptionComplete(data);
      }
    });

    Pubsub.subscribe(Pubsub.topics.TRACK_EXPERIMENTS, function (obj) {
      // track to GA
      if (providers.GA.initialized) {
        providers.GA.trackExperiments(obj.experiments);
      }
    });

    this.setupGA()
    this.setupNewsbeat();
    this.setupLinkpulse();
    initialized = true;
  }

  // destroy
  function destroy () {
    initialized = false;
    for (var key in providers) {
      if (providers.hasOwnProperty(key)) {
        providers[key].initialized = false;
      }
    }
  }

  /** @interface */
  return {
    getCategory: getCategory,
    setupGA: providers.GA.setup,
    setupNewsbeat: providers.Newsbeat.setup,
    setupLinkpulse: providers.Linkpulse.setup,
    initialize: initialize,
    destroy: destroy
  };

});

